import React, { type JSX } from 'react';
import { makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import Quill from 'quill';

export type SnapshotEditorProps = {
  name: string;
  content: string;
  createdAt: Date;
  createdByUser: boolean;
};

/**
 * Read-only render of a historical snapshot. Mirrors the shared-note view: the
 * Quill snow toolbar is disabled and the reading column is laid out in CSS
 * (see `.snapshot-note-wrapper` in app.scss) rather than via JS height hacks.
 */
@observer
export default class SnapshotEditor extends React.Component<SnapshotEditorProps> {
  private _editorContainerRef: React.RefObject<HTMLDivElement> = React.createRef();
  private _quillInstance: Quill | null = null;

  constructor(props: SnapshotEditorProps){
    super(props);
    makeObservable(this);
  }

  componentDidMount(): void {
    if (this._editorContainerRef.current) {
      this._quillInstance = new Quill(this._editorContainerRef.current, {
        theme: 'snow',
        readOnly: true,
        modules: {
          toolbar: false,
          history: false
        }
      });

      // Set content
      if (this.props.content) {
        try {
          const delta = JSON.parse(this.props.content);
          this._quillInstance.setContents(delta);
        } catch (e) {
          // Fallback to plain text if not valid JSON
          this._quillInstance.setText(this.props.content || '');
        }
      }
    }
  }

  componentWillUnmount(): void {
    if (this._quillInstance) {
      this._quillInstance = null;
    }
  }

  render(): JSX.Element{
    return (
      <div className="snapshot-editor-wrapper">
        <div id="snow-container">
          <div ref={this._editorContainerRef} />
        </div>
      </div>
    );
  }
}